import { css } from '@emotion/react'
import { ColorScale } from 'bold-ui/lib/styles/colors'
import { CardRadioGroupField, CardRadioGroupFieldOption } from 'components/form/field/CardRadioGroupField'
import { Color } from 'csstype'
import { MetaPath } from 'util/metaPath'

import { ClassificacaoRiscoVulnerabilidadeEnum, classificacaoRiscoVulnerabilidadeRecord } from '../model-esusRegulacao'

interface ClassificacaoRiscoFieldProps {
  name: MetaPath<ClassificacaoRiscoVulnerabilidadeEnum>
  required?: boolean
}

export function ClassificacaoRiscoField(props: Readonly<ClassificacaoRiscoFieldProps>) {
  const { name, required } = props

  return (
    <div css={styles.wrapper}>
      <CardRadioGroupField
        name={name}
        label='Classificação de risco e/ou vulnerabilidade'
        options={options}
        required={required}
      />
    </div>
  )
}

const items = Object.entries(classificacaoRiscoVulnerabilidadeRecord)

const options: CardRadioGroupFieldOption<ClassificacaoRiscoVulnerabilidadeEnum>[] = items.map(
  ([key, item]: [
    ClassificacaoRiscoVulnerabilidadeEnum,
    { label: string; mainColor: Color; colorScale: ColorScale }
  ]) => ({
    label: item.label,
    colorScale: item.colorScale,
    value: key,
  })
)

const styles = {
  wrapper: css`
    label span:first-of-type {
      flex-shrink: 0;
    }

    div:has(> [role='button']) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    [role='button']:not(:has(input[value='${ClassificacaoRiscoVulnerabilidadeEnum.NAO_CLASSIFICADO}']))
      label
      span:last-of-type {
      white-space: nowrap;
    }
  `,
}
